module.exports = __webpack_public_path__ + "img/white_share.bd865f65.png";